import column from '../../../../../common/list-table/helpers/columns';

export const MRDContactsTableColumns = (data) => {
  const { FilteredTextColumn, NotFilteredReadOnlyCheckboxColumn } = column(data);
  return [{
    Header: '',
    columns: [
      new FilteredTextColumn('First Name', 'firstName'),
      new FilteredTextColumn('Last Name', 'lastName'),
      new FilteredTextColumn('Phone', 'phoneNumber'),
      new FilteredTextColumn('Email', 'emailAddress'),
      new NotFilteredReadOnlyCheckboxColumn('Notify for failure', 'notifyOnFailure'),
    ],
  }];
};
